export default "__VITE_ASSET__DKM6ziWI__"